import type { StaticImageData } from 'next/image';
import Image from 'next/image';
import type { FC } from 'react';

import Icon from '../Icon';
import Text from '../Text';

type Props = {
  opinion: string;
  headshots?: StaticImageData;
  companyLogo?: StaticImageData;
  name: string;
  companyRole: string;
};

const Opinion: FC<Props> = ({
  name,
  companyRole,
  companyLogo,
  headshots,
  opinion,
}) => {
  return (
    <div className="flex flex-1 flex-col gap-3 rounded-xl border border-jb-neutral-100/30 bg-[#7A46FF1A] p-6">
      <Icon
        icon="icomoon-free:quotes-left"
        className="rounded-full text-jb-success-400"
        fontSize={26}
      />
      <Text variant="jb-body-large" className="text-jb-neutral-100">
        {'\u201C'}
        {opinion}
        {'\u201D'}
      </Text>
      <div className="flex flex-row gap-6">
        {headshots && (
          <div className="aspect-square h-20">
            <Image src={headshots} alt="" />
          </div>
        )}
        <div className="flex flex-col gap-1">
          <Text variant="jb-h5" className="text-jb-neutral-100">
            {name.toLocaleUpperCase()}
          </Text>
          <Text className="text-jb-neutral-600" variant="jb-body-large">
            {companyRole}
          </Text>
          {companyLogo && (
            <Image src={companyLogo} alt="" className="mt-3 h-8 w-fit" />
          )}
        </div>
      </div>
    </div>
  );
};

export default Opinion;
